import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, apiJson } from "@/api/client.js";
import { DataTable } from "@/components/DataTable.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";
import { localizeDemo } from "@/i18n/orignalI18n.js";

export function ObservationPage() {
  const { ui, lang } = useOrignalUi();
  const [params] = useSearchParams();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", interest: "interessant", revisit: false, latitude: null, longitude: null, accuracy: null });
  const [gps, setGps] = useState("");

  async function reload() {
    setItems((await api("/api/observations")).items);
  }
  useEffect(() => {
    reload().catch(() => {});
    if (params.get("new") === "1") useGps();
  }, []);

  function useGps() {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition((pos) => {
      setForm((f) => ({ ...f, latitude: pos.coords.latitude, longitude: pos.coords.longitude, accuracy: pos.coords.accuracy }));
      setGps(`${pos.coords.latitude.toFixed(5)}, ${pos.coords.longitude.toFixed(5)}`);
    });
  }

  async function submit(e) {
    e.preventDefault();
    const result = await apiJson("/api/observations", { ...form, title: form.title || ui.observations.title });
    setForm({ title: "", body: "", interest: "interessant", revisit: false, latitude: form.latitude, longitude: form.longitude, accuracy: form.accuracy });
    if (!result._offline) await reload();
  }

  return (
    <main className="og-page" data-testid="page-observations">
      <h1>{ui.observations.title}</h1>
      <p className="og-lead">{ui.observations.subtitle}</p>
      <form className="og-card og-form" onSubmit={submit} data-testid="observation-form">
        <button type="button" className="og-btn" onClick={useGps} data-testid="obs-gps">{ui.app.useGps}</button>
        <p className="og-hint">{gps || ui.app.noGps}</p>
        <label>
          {ui.territory.name}
          <input className="og-input" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="obs-title" />
        </label>
        <label>
          {ui.observations.note}
          <textarea className="og-input" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="obs-body" />
        </label>
        <label>
          {ui.territory.interest}
          <select className="og-input" value={form.interest} onChange={(e) => setForm({ ...form, interest: e.target.value })}>
            {["faible", "interessant", "important", "prioritaire"].map((k) => <option key={k} value={k}>{ui.status[k]}</option>)}
          </select>
        </label>
        <label className="og-check"><input type="checkbox" checked={form.revisit} onChange={(e) => setForm({ ...form, revisit: e.target.checked })} /> {ui.today.revisit}</label>
        <button className="og-btn og-btn--primary" type="submit" data-testid="obs-submit">{ui.observations.add}</button>
      </form>
      <DataTable
        rows={items.map((o) => ({ ...o, title: localizeDemo(o.title, lang), interestLabel: ui.status[o.interest] || o.interest }))}
        searchKeys={["title", "body"]}
        columns={[{ key: "title", label: ui.observations.title }, { key: "interestLabel", label: ui.territory.interest }]}
        emptyLabel={ui.observations.empty}
        testId="observations-table"
      />
    </main>
  );
}
